import { IBaseTextBoxEditorProps, BaseTextBoxEditor } from "./BaseTextBoxEditor";

import { ITextBoxSpecificProps, TextBox } from "./TextBox";

import { Guid } from "../Utils/Guid";
import * as React from "react";

export interface ITextBoxEditorProps
    extends IBaseTextBoxEditorProps,
        ITextBoxSpecificProps,
        React.Props<TextBoxEditor> {}

export class TextBoxEditor extends BaseTextBoxEditor<ITextBoxEditorProps> {
    private _prependedTextId = Guid.getNext();
    private _appenedTextId = Guid.getNext();
    private _textBoxRef: TextBox;

    constructor(props: ITextBoxEditorProps) {
        super(props);
    }

    protected getInput(): JSX.Element {
        if (this.props.textPrepend || this.props.textAppend) {
            return (
                <div className="input-group">
                    {this.props.textPrepend && (
                        <span className="input-text-addon" id={this._prependedTextId}>
                            {this.props.textPrepend}
                        </span>
                    )}
                    {this.getTextBoxInput()}
                    {this.props.textAppend && (
                        <span className="input-text-addon" id={this._appenedTextId}>
                            {this.props.textAppend}
                        </span>
                    )}
                </div>
            );
        } else {
            return this.getTextBoxInput();
        }
    }

    private getTextBoxInput(): JSX.Element {
        return (
           
                <TextBox
                    {...(this.props as any)}
                    id={this.state.inputGroupId}
                    onValidationResultChange={(isValid: boolean, errors: string[], showValidationMessages: boolean) =>
                        this.handleValidationResultChange(isValid, errors, showValidationMessages)
                    }
                    ariaDescribedby={
                        this._errorMessageId +
                        " " +
                        this._prependedTextId +
                        " " +
                        this._appenedTextId +
                        " " +
                        this._infoTextId +
                        (this.props.ariaDescribedby ? " " + this.props.ariaDescribedby : "")
                    }
                    ariaInvalidCanBeShown={this.state.typingFinished}
                    ariaInvalidShouldBeShown={!this.state.isValidOutside}
                    onBlur={(value) => this.onBlur(value)}
                    ref={(ref: TextBox) => (this._textBoxRef = ref)}
                />
           
        );
    }

    private onBlur(value: string): void {
        if (this.props.onBlur) {
            this.props.onBlur(value);
        }

        this.setState({ typingFinished: true });
    }

    private handleValidationResultChange(isValid: boolean, errors: string[], showValidationMessages: boolean): void {
        this.onValidationResultChange(isValid, errors, showValidationMessages);

        if (this.props.onValidationResultChange) {
            this.props.onValidationResultChange(isValid, errors, showValidationMessages);
        }

        if (this.props.onValidation) {
            this.props.onValidation(errors);
        }
    }

    public completelyRecalculateValidation(): boolean {
        return this._textBoxRef.completelyRecalculateValidation();
    }
}
